import {collectionQueryOptions} from '@blesk-frontend/api';
import {createFileRoute} from '@tanstack/react-router';
import {CollectionDetailPage} from '@/features/collections';

export const Route = createFileRoute('/_app/collections/$collectionId/')({
  beforeLoad: ({context: {queryClient}, params: {collectionId}}) => ({
    getTitle: () => {
      const collection = queryClient.getQueryData(collectionQueryOptions(collectionId).queryKey);
      return collection?.name || 'Коллекция';
    },
  }),
  component: () => <CollectionDetailPage />,
});
